import cache from "./cache";
import request from "./request";
import cookie from "./cookie";
import * as url from "./url";
import * as language from "./language";
import wxShare from "./wxShare";
import wxApi from "./wxApi";
import log from "./log";
import rem from "./rem";
import * as elkLib from './libs/elk';
import {
  itil,
  elk,
  acc,
  initReport,
  reportIndexPvUvAndTimeCost,
} from "./report";
import vueTap from "./vTap";
import * as util from "./util";
import event from "./event";
import * as type from "./type";
import * as error from "./error";
import { init as mtaInit, hottag, biHottag, registGlobalBiParam } from "./libs/mta";
import { getUrlParam } from "./url";
import { clear } from "./cache";
import * as windowHelper from "./window-helper";
import sessionStorage from "./sessionStorage";
import tenpayStorage from "./tenpay-storage";
import * as user from "./user";
import * as grey from "./grey";
import { alarm as alarm, setAlarm, AlarmException } from "./alarm";
if (getUrlParam("clear") === "1") {
  // 如果有清除标志 则清空
  clear();
}

const CustomException = error.CustomException;

export {
  cache,
  request,
  url,
  cookie,
  wxShare,
  rem,
  language,
  itil,
  elk,
  acc,
  initReport,
  reportIndexPvUvAndTimeCost,
  log,
  vueTap,
  wxApi,
  event,
  type,
  error,
  hottag,
  biHottag,
  mtaInit,
  registGlobalBiParam,
  util,
  sessionStorage,
  CustomException,
  windowHelper,
  tenpayStorage,
  user,
  grey,
  alarm,
  setAlarm,
  AlarmException,
  elkLib
};
